// TopToolbar.jsx
import React from "react";
import { BRAND_ASSETS } from "../../brandAssets";

const NAV_TABS = [
  { id: "overview", label: "Introduction" },
  { id: "dataDashboard", label: "Data Dashboard" },
  { id: "resources", label: "Resources" },
  { id: "stories", label: "Stories of Hope" },
  { id: "aboutUs", label: "About Us" },
];

function TopToolbar({
  activeTab,
  onChangeTab,
  currentUser,
  onLoginClick,
  onLogout,
}) {
  return (
    <header className="top-toolbar dashboard-topbar fade-in-up">
      <div className="dashboard-brand-block">
        <img className="dashboard-brand-logo dashboard-brand-logo-mark" src={BRAND_ASSETS.logomarkColor} alt="HopeCounts" />
        <div>
          <strong className="dashboard-brand-title">Suicide Prevention Dashboard</strong>
          <p>Hope Counts</p>
        </div>
      </div>

      <nav className="dashboard-tabs" aria-label="Dashboard sections">
        {NAV_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`dashboard-tab-button ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => onChangeTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <div className="dashboard-auth-actions">
        {currentUser ? (
          <>
            <span className="dashboard-user-pill">{currentUser.role}</span>
            <button type="button" onClick={onLogout} className="toolbar-button toolbar-button-secondary">
              Logout
            </button>
          </>
        ) : (
          <button type="button" onClick={onLoginClick} className="toolbar-button toolbar-button-secondary">
            Administrative Login
          </button>
        )}
      </div>
    </header>
  );
}

export default TopToolbar;
